'use strict';

const jQuery = require('jquery');

require('jquery-ui/ui/widgets/sortable');

const FormBuilder = require('./../../builder');
const Container = require('./../../../../core/container');

require('./../../../../services/touchPunch');

let ElementClass = require('./../../elementClass');

let indexTpl = require('./template/index.hbs');
let itemTpl = require('./template/item.hbs');
let itemEditTpl = require('./template/item_edit.hbs');

FormBuilder.register('textList', function(config) {
  let self = {};
  let $index;
  let $input;
  let $btnAdd;
  let $wrapper;

  self = new ElementClass(config);

  self.value = config.value;

  self.addItem = function(text) {
    let $item = jQuery(itemTpl({'text': text}));
    let onRemove = config.onRemove || function() {
      jQuery(this).parents('.item:first').remove();
    };

    $item.find('.remove').on(Container.get('isMobile') ? 'touchstart MSPointerDown' : 'click', onRemove);

    $item.find('.edit').on(Container.get('isMobile') ? 'touchstart MSPointerDown' : 'click', function() {
      let $edit = jQuery(itemEditTpl({'text': text}));

      $edit.insertBefore($item);

      $edit.find('input').focus();

      $edit.find('.edit-item').on(Container.get('isMobile') ? 'touchstart MSPointerDown' : 'click', function() {
        let text = $edit.find('input[name="text"]').val();

        $item.find('.cloud-label').text(text);

        $edit.remove();
        $item.removeClass('d-none');
      });

      $item.addClass('d-none');
    });

    $input.val('');
    $input.focus();

    $wrapper.append($item);
  };

  self.render = function($wrap) {
    $index = jQuery(indexTpl({label: self.label, placeholder: config.placeholder || 'add_item'}));
    $input = $index.find('input');
    $btnAdd = $index.find('.add');
    $wrapper = $index.find('.item-wrapper');

    $btnAdd.on(Container.get('isMobile') ? 'touchstart MSPointerDown' : 'click', function() {
      let text = $input.val();

      if (text) {
        self.addItem($input.val());
      }

      $input.focus();
    });

    $wrapper.sortable({
      'containment': 'parent',
      'items': '.item-added',
      'tolerance': 'pointer',
    });

    $wrap.append($index);

    for (let item of self.value) {
      self.addItem(item);
    }
  };

  self.getData = function() {
    let data = [];

    $wrapper.find('.item').each(function() {
      data.push(jQuery(this).find('.cloud-label').text());
    });

    return data;
  };

  return self;
});
